module.exports = __webpack_public_path__ + "img/techobg.1313d55f.jpg";